/**
 * El precio de lanzamiento cierra al final del segundo día siguiente, de modo
 * que la cuenta atrás siempre muestra algo más de dos días y nunca se reinicia
 * al recargar la página.
 *
 * Para cerrar la promoción en una fecha fija, definí FIXED_DEADLINE con un ISO.
 */
const FIXED_DEADLINE: string | null = null

export function getOfferDeadline(): string {
  if (FIXED_DEADLINE) return FIXED_DEADLINE
  const deadline = new Date()
  deadline.setDate(deadline.getDate() + 2)
  deadline.setHours(23, 59, 59, 999)
  return deadline.toISOString()
}

/** Porcentaje de cupos de lanzamiento ya tomados. */
export const spotsTakenPercent = 65
